/**
 * Choice values for oc_keyrequest (global option sets in Dataverse).
 */
export const KEY_REQUEST_ACTION = {
  GRANT: 161730000,
  REVOKE: 161730001,
  LIST: 161730002
};

export const KEY_REQUEST_SCOPE = {
  SINGLE_LOCK: 161730000,
  ALL_LOCKS_FOR_RESIDENT: 161730001,
  ALL_LOCKS: 161730002
};

export const KEY_REQUEST_STATUS = {
  PENDING: 161730000,
  PROCESSING: 161730001,
  COMPLETED: 161730002,
  FAILED: 161730003
};

export const KEY_REQUEST_STATUS_LABELS = {
  [KEY_REQUEST_STATUS.PENDING]: 'Venter',
  [KEY_REQUEST_STATUS.PROCESSING]: 'Behandler',
  [KEY_REQUEST_STATUS.COMPLETED]: 'Fullført',
  [KEY_REQUEST_STATUS.FAILED]: 'Feilet'
};

export const KEY_REQUEST_ACTION_LABELS = {
  [KEY_REQUEST_ACTION.GRANT]: 'Gi nøkkel',
  [KEY_REQUEST_ACTION.REVOKE]: 'Trekk tilbake',
  [KEY_REQUEST_ACTION.LIST]: 'List nøkler'
};

export const KEY_REQUEST_SCOPE_LABELS = {
  [KEY_REQUEST_SCOPE.SINGLE_LOCK]: 'Én lås',
  [KEY_REQUEST_SCOPE.ALL_LOCKS_FOR_RESIDENT]: 'Alle lås for innbygger',
  [KEY_REQUEST_SCOPE.ALL_LOCKS]: 'Alle Unloc-låser'
};

/** Unloc CreateKeys rejects durationMinutes below 10. */
export const KEY_REQUEST_DURATION_MIN = 10;
export const KEY_REQUEST_DURATION_MAX = 525600;
export const KEY_REQUEST_DURATION_DEFAULT = 60;

/**
 * Normalize Norwegian mobile numbers to E.164 (+47…).
 * @param {string} input
 * @returns {string|null}
 */
export function normalizeMobileNumber(input) {
  if (!input || typeof input !== 'string') {
    return null;
  }

  const digits = input.replace(/\s+/g, '').replace(/-/g, '');
  if (!digits) {
    return null;
  }

  if (/^\+47\d{8}$/.test(digits)) {
    return digits;
  }

  if (/^0047\d{8}$/.test(digits)) {
    return `+47${digits.slice(4)}`;
  }

  if (/^47\d{8}$/.test(digits)) {
    return `+${digits}`;
  }

  if (/^\d{8}$/.test(digits)) {
    return `+47${digits}`;
  }

  return null;
}

export function isValidMobileNumber(input) {
  return normalizeMobileNumber(input) !== null;
}
